import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import { Colors } from "~/jsx/theme";

const StyledButton = styled.div`
  cursor: not-allowed;
  &.clickable {
    cursor: pointer;
  }

  & * {
    cursor: not-allowed;
  }
  &.clickable * {
    cursor: pointer;
  }
`;

const variants = {
  action: {
    padding: "18px 24px",
  },
  secondary: {
    color: Colors.grey.darkText,
    background: Colors.yellow.light,
    border: `solid 1px ${Colors.common.black}`,
    boxShadow: "none",
  },
};

type Variant = keyof typeof variants;

const TScheck: Record<string, CSSProperties> = variants;

export const XButton = ({
  children,
  style,
  onClick,
  variant = [],
}: {
  children: React.ReactNode;
  style?: CSSProperties;
  onClick?: () => void;
  variant?: Variant | Variant[];
}) => {
  const color = onClick ? "orange" : "lightgrey";
  const variantArray = Array.isArray(variant) ? variant : [variant];
  const baseStyle: CSSProperties = {
    backgroundColor: color,
    border: `solid 1px ${color}`,
    padding: 12,
    borderRadius: 8,
    boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.3)",
  };
  variantArray.forEach((variant) => {
    Object.assign(baseStyle, variants[variant]);
  });
  Object.assign(baseStyle, style);
  return (
    <StyledButton
      className={onClick ? "clickable" : ""}
      onClick={onClick}
      style={baseStyle}
    >
      {children}
    </StyledButton>
  );
};
